import PromptInstruction from '@/models/PromptInstruction';
import { Tree } from './Tree';
import { isEqual } from 'lodash';

export default class TreePrompt extends Tree<number, PromptInstruction> {
  insert(element: PromptInstruction, parentElementId?: number) {
    const node = this.nodes[element.id];
    if (node && isEqual(node.data, element)) return;
    super.insert(element, parentElementId);
  }
}
